'use strict';

var JSConstants = require('_core_ext/pages/blog/constants');

/**
 * @private
 * @function
 * @description Binds events to the blog pages
 */

function initializeEvents() {

    $(JSConstants.CLASS_BLOG_SEARCH_FORM).on('submit', function (event) {
        var $searchField = $(JSConstants.CLASS_BLOG_SEARCH_INPUT),
            searchFieldValue = $searchField.val(),
            searchFieldFilled = searchFieldValue && searchFieldValue !== $searchField.attr('placeholder');

        if (!searchFieldFilled) {
            event.preventDefault();
        }
    });

}

exports.init = function () {
    initializeEvents();
};
